<template>
    <div>
        <card v-if="!viewQuizDetail" header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">Daftar Penilaian</h6>
                </div>
                <div v-if="overview.is_admin" class="col-lg-6 text-lg-right">
                    <b-button variant="primary" size="sm" @click="showAppraisalFormModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> Tambah Penilaian</b-button>
                </div>
            </div>
            <div v-if="overview.quiz_list && overview.quiz_list.length > 0" class="text-center text-muted">
                <b-table responsive striped hover :items="overview.quiz_list" :fields="table.fields" thead-class="d-none">
                    <template #cell(name)="data">
                        <div class="row p-0">
                            <div class="col-lg-9 appraisal-name line-with-icon my-2 px-4" style="cursor: pointer;" v-b-toggle="'collapse-appraisal-'+data.item.id">
                                <i class="clr-red fa fa-suitcase" aria-hidden="true"></i>
                                <span class="ml-1">
                                    {{data.item.name}}
                                    <br>
                                    <sup>{{data.item.created}}</sup>
                                </span>
                            </div>
                            <!-- <div v-if="overview.is_admin" class="col-lg-3 text-lg-right my-2 px-4">
                                <b-badge v-if="data.item.is_publish == '1'" variant="info">Published</b-badge>
                                <b-badge v-else variant="info">Draft</b-badge>
                            </div> -->
                        </div>
                        <b-collapse :id="'collapse-appraisal-'+data.item.id">
                            <b-card>
                                <div><i class="clr-red fa fa-book" aria-hidden="true"></i> <b>Bentuk Pengerjaan</b> : {{data.item.view_type}}</div>
                                <div><i class="clr-red fa fa-calendar" aria-hidden="true"></i> <b>Tenggat Waktu</b> : {{data.item.view_date}}</div>
                                <div><i class="clr-red fa fa-clock" aria-hidden="true"></i> <b>Waktu Pengerjaan</b> : {{data.item.duration}} Menit</div>
                                <div><i class="clr-red fa fa-file" aria-hidden="true"></i> <b>Jumlah Soal</b> : {{data.item.total_soal}}</div>
                                <hr>
                                <div><b>Petunjuk Pengerjaan Penilaian Hasil Belajar :</b></div>
                                <div v-html="data.item.tutorial"></div>
                                <hr>
                                <div  v-if="overview.is_admin==0 && ((data.item.is_current_test==1 && data.item.is_has_test==1))" >
                                    <i class="clr-red fa fa-calendar-check" aria-hidden="true"></i> <b>Nilai Penilaian Hasil Belajar : <span style="font-size: 16px;">{{data.item.score}}</span></b>
                                    <hr>
                                </div>
                                <div v-if="overview.is_admin" class="">
                                    <router-link :to="{ name: 'print-quiz', params:{ quizId: data.item.id} }" target="_blank"><b-button variant="primary" size="sm"><i class="fa fa-print" aria-hidden="true"></i> Print Soal</b-button></router-link>
                                    <router-link :to="{ name: 'student-appraisal-list', params:{ appraisalId: data.item.id} }" class="float-right"><b-button variant="primary" size="sm"><i class=" fa fa-eye" aria-hidden="true"></i> Lihat Hasil Penilaian</b-button></router-link>
                                </div>
                                <div v-if="user.type == 'murid' && data.item.total_soal > 0" class="text-right">
                                    <div v-if="data.item.is_current_test">
                                        <b-button v-if="data.item.is_has_test" variant="primary" size="sm" @click.prevent="reDoExams(data.item)"><i class="fa fa-clock" aria-hidden="true"></i> Kerjakan Ulang</b-button>
                                        <b-button v-else variant="primary" size="sm" @click.prevent="doExams(data.item)"><i class="fa fa-clock" aria-hidden="true"></i> Kerjakan</b-button>
                                    </div>
                                    <div v-else>
                                        <div id="tooltip-target-1">
                                            <b-button size="sm" disabled ><i class="fa fa-clock" aria-hidden="true"></i> Tidak dapat mengerjakan</b-button>
                                        </div>
                                        <b-tooltip target="tooltip-target-1" triggers="hover" placement="bottom">
                                            Tidak dapat mengerjakan karena tenggat waktu pengerjaan tidak sesuai dengan waktu sekarang
                                        </b-tooltip>
                                    </div>
                                </div>
                            </b-card>
                        </b-collapse>
                    </template>
                    <template v-if="overview.is_admin" #cell(actions)="data">
                        <div class="my-2">
                            <router-link :to="{ name: 'modul-appraisal-question', params:{ modulId: overview.id,quizId: data.item.id} }" class="icon-clicked p-1"><i class="fa fa-edit" aria-hidden="true"></i></router-link>
                            <!-- <a href="javascript:void(0)" class="icon-clicked p-1" @click="viewDetail(data.item.id)"><i class="clr-red fa fa-edit" aria-hidden="true"></i></a> -->
                            <a href="javascript:void(0)" class="icon-clicked p-1" @click="confirmDeleteAppraisal(data.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                        </div>
                    </template>
                </b-table>
            </div>
            <div v-else class="p-2 text-center text-muted">
                Saat ini belum ada penilaian
            </div>
        </card>
        <question-list
            v-else
            :quizId="quizId"
        ></question-list>
        <b-modal
            ref="appraisal-form-modal"
            class="appraisal-form-modal"
            size="lg"
            title="Tambah Penilaian"
            @show="resetAppraisalForm"
            @hidden="resetAppraisalForm"
            hide-footer
            no-close-on-backdrop
        >
            <appraisal-form
                :modulId="modulId"
                :appraisalType="appraisalType"
            ></appraisal-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import AppraisalForm from "../../../components/Main/Appraisal/AppraisalForm";
    // import AppraisalDetail from "../../../components/Main/Appraisal/AppraisalDetail";
	import QuestionList from "../../../components/Main/Appraisal/QuestionList";
    export default {
        components: {
            AppraisalForm,
            QuestionList,
            // AppraisalDetail
        },
        data() {
            return {
                modulId: this.$route.params.modulId,
                table: {
                    fields: [
                        { key: 'name', label: 'Name', class: 'task-name text-left'  },
                        { key: 'actions', label: 'Actions', class: 'action-column' }
                    ],
                },
                viewQuizDetail: false,
                quizId: null
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                overview: 'getAppraisalOverview',
                appraisalType: 'getAppraisalType'
            })
        },
        methods: {
            showAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].show()
            },
            hideAppraisalFormModal() {
                this.$refs['appraisal-form-modal'].hide()
                this.resetAppraisalForm()
            },
            resetAppraisalForm() {
                EventBus.$emit('resetAppraisalForm', true)
            },
            viewDetail(id) {
                this.$nextTick(() => {
                    this.quizId = id
                    this.viewQuizDetail = true
                });
            },
            hideDetail() {
                this.$nextTick(() => {
                    this.viewQuizDetail = false
                });
            },
			async getAppraisalType() {
				await this.$store.dispatch('getAppraisalType')
			},
			async getAppraisalOverview() {
                let modulId = this.$route.params.modulId
				await this.$store.dispatch('getAppraisalOverview', { modulId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async confirmDeleteAppraisal(appraisalId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteAppraisal(appraisalId)
                    }
                })
			},
            async deleteAppraisal(id) {
				await this.$store.dispatch('deleteAppraisal', { id })
					.then((res) => {
                        this.getAppraisalOverview()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            reDoExams(param) {
                this.$swal.fire({
                    title: 'Perhatian!',
                    text: 'Apakah anda yakin akan mengerjakan kembali penilaian hasil belajar?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        let appraisalId = param.id
                        this.$router.push({ name: 'appraisal-test', params: { appraisalId: appraisalId }  })
                    }
                })
            },
            doExams(param) {
                this.$swal.fire({
                    title: 'Perhatian!',
                    html: 'Apakah anda yakin akan mengerjakan penilaian <b>'+ param.name +'</b>?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        let appraisalId = param.id
                        this.$router.push({ name: 'appraisal-test', params: { appraisalId: appraisalId }  })
                    }
                })
            }
        },
        async created() {
            await this.setCurrentModulId(this.$route.params.modulId)
            await this.getAppraisalOverview()
            await this.getAppraisalType()
			EventBus.$on('hideAppraisalFormModal', (val) => {
				if (val) {
					this.hideAppraisalFormModal()
				}
			})
			EventBus.$on('hideDetail', (val) => {
				if (val) {
					this.hideDetail()
				}
			})
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
</style>